module.exports = __webpack_public_path__ + "media/images/custom_page/younite_event/younite-event-zh-bc72089c56b0ded27214d7cf9ce6801d.png";